<template>
  <div class="d-flex-column justify-start work_with_us_hero_banner gap-0">
    <!-- TOP HEADER -->
    <div class="height-max-content booster_count_tag">
      <p class="t-white regular-xl font-family-2 t-light">
        {{ $t("work_with_us_2.sub_first") }}
      </p>
      <div class="d-flex-row width-max-content gap-0 booster_avatars">
        <img src="/images/avatars/avatar6.webp" class="booster_avatar" />
        <img src="/images/avatars/avatar7.webp" class="booster_avatar" />
        <img src="/images/avatars/avatar8.webp" class="booster_avatar" />
      </div>
      <p class="t-light regular-xl font-family-2">
        {{ $t("work_with_us_2.sub_second") }}
      </p>
    </div>

    <div
      class="d-flex-column justify-start title_container"
      style="margin-left: 0px"
    >
      <div class="d-flex-column gap-0">
        <h1 class="t-white font-family-1 title-h1 text-center">
          {{ $t("work_with_us_2.title_first") }}
        </h1>
        <h1 class="t-white font-family-1 title-h1 text-center">
          {{ $t("work_with_us_2.title_second") }}
        </h1>
      </div>
      <p class="t-light font-family-2 regular-xxl text-center">
        {{ $t("work_with_us_2.sub_title") }}
      </p>
    </div>

    <button
      @click="navToJobs"
      class="primary filled b-radius-9 font-family-1 cta_button height-48 xxl t-dark regular-l f-w-600 full-width max-width-213px"
    >
      {{ $t("work_with_us.apply_now") }}
    </button>

    <HeroImages />

    <div class="d-flex-column bottom_container gap-32">
      <p class="t-light regular-xl font-family-2 text-center">
        {{ $t("work_with_us_2.hiring_sellers") }}
      </p>
      <LoopBanner />
    </div>
  </div>
</template>

<script setup>
import HeroImages from "../work-with-us/HeroImages.vue";
import LoopBanner from "../work-with-us/LoopBanner.vue";
const navToJobs = () => {
  const el = document.getElementById("open-positions");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }
};
</script>

<style lang="scss">
.work_with_us_hero_banner {
  min-height: 70vh;
  max-height: 697px;
  width: 100%;
  padding-top: 70px;
  position: relative;
  .bottom_container {
    margin-top: auto;
  }

  .booster_count_tag {
    padding: 6px 16px;
    border-radius: 99px;
    background-color: var(--bg-medium);
    z-index: 1;
    max-width: max-content;
    display: inline-flex;
    gap: 5px;
  }
  .title_container {
    margin-top: 50px;
  }
  .cta_button {
    margin-top: 42px;
  }
  .booster_avatars {
    .booster_avatar {
      width: 24px;
      height: 24px;
      border-radius: 40.8px;
      border: 1px solid var(--Dark-shade-1, #090909);
      position: relative;

      &:first-child {
        z-index: 2;
      }
      &:nth-child(2) {
        z-index: 1;
      }
      &:not(&:first-child) {
        margin-left: -8px; /* Adjust this value as needed */
      }
    }
  }
  @media screen and (max-width: 900px) {
  }

  @media screen and (max-width: 600px) {
    padding-top: 150px;
    .bottom_container {
      margin-top: 56px;
    }
    .title_container {
      max-width: 90%;
    }
    .booster_count_tag {
      display: none;
    }
  }
}
</style>
